module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_11.73d32cc6.jpg";